define((require) => {
    "use strict";

    const ViewController        = require("editor/util/ViewController");
    const ChannelPropertiesView = require("ui/publish/channelSetup/ChannelPropertiesView");
    const Channel               = require("ui/publish/channelSetup/Channel");
    const Lightbox              = require("shared/ui/common/Lightbox");
    const LoggedIn              = require("shared/security/LoggedIn");
    const Time                  = require("shared/services/Time");
    const Preconditions         = require("shared/util/Preconditions");

    /**
     * View Controller of the manual channel setup view.
     *
     */
    return ViewController.extend({

        /**
         * Triggered when the user has clicked on an row for a given channel to edit. <p>
         *
         * <tt>field</tt> will be the class name of the target element clicked in the row, e.g. "next-experience"
         * if the title of the Experience scheduled to go live next was clicked.
         *
         * @param {String}  property The channel property the user clicked on to gain focus now, if any, e.g.
         *                           "name", or "experience". Can be falsey, i.e. just open view without focus.
         */
        onViewCreateNewSlotOpened() {
            const principal = LoggedIn.principal();
            const {
                projectContext, allowedToPublish, publishableDescriptors, publishableCollection, channelCollection
            } = this.options;
            const newChannel = new Channel({
                    companyId: principal.get("companyId"),
                    createdBy: principal.get("userId"),
                    createdAt: Time.server(),
                    manual:    true
                }),
                channelPropertiesView = new ChannelPropertiesView({
                    model: newChannel,
                    isNewSlot: true,
                    focus: "name",
                    channelCollection,
                    publishableDescriptors,
                    publishableCollection,
                    projectContext,
                    allowedToPublish
                });

            const options = {
                css: {
                    width: 830
                },
                editorEventProperties: {
                    modalType: "ChannelSlotProperties",
                    triggerOrigin: "CreateNewChannelSlotModal",
                    isNewSlot: true
                }
            };
            new Lightbox(channelPropertiesView, options).open();

            channelPropertiesView.once("done", (channel) => {
                this.view.trigger("handleChanges", "add", channel);
            });
        },

        onViewHandleChanges(type, channel) {
            Preconditions.checkArgument(type);

            if (type === "add") {
                this.view.channelChangesInfo.handleAdd(channel);
                this.view.collection.add(channel, 0);
            }

            if (type === "update") {
                this.view.channelChangesInfo.handleUpdate(channel);
            }

            if (type === "delete") {
                this.view.channelChangesInfo.handleDelete(channel);
                this.view.collection.remove(channel);
            }

            this.view.shouldButtonChange();
        }

    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/publish/channelSetup/ChannelSetupManualViewController.js